import { Button } from "@legal-500/legal500-design-system";
import type { ReactNode } from "react";
import styles from "./forms/Form.module.css";

type FormButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  variant?: "primary" | "outlined" | "danger";
  disabled?: boolean;
};

export function FormButton({
  children,
  onClick,
  type = "button",
  variant = "outlined",
  disabled,
}: FormButtonProps) {
  if (variant === "primary") {
    return (
      <Button type={type} onClick={onClick} variant="contained" color="primary" disabled={disabled}>
        {children}
      </Button>
    );
  }

  if (variant === "danger") {
    return (
      <Button
        type={type}
        onClick={onClick}
        variant="outlined"
        color="default"
        className={styles.dangerButton}
        disabled={disabled}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button type={type} onClick={onClick} variant="outlined" color="default" disabled={disabled}>
      {children}
    </Button>
  );
}
